const FeParts = () => import("Modules/inventory/fe_parts/views/Parts");
const FePartsForm = () => import("Modules/inventory/fe_parts/views/PartsForm");

export default {
    children: [
        {
            path: "inventory/fe_parts",
            name: "fe_parts",
            component: FeParts,
            meta: {
                requiresAuth: true,
                title: "lang.parts",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["fe_parts.read"],
            },
        },
        {
            path: "inventory/fe_part/:id?",
            name: "fe_part",
            component: FePartsForm,
            meta: {
                requiresAuth: true,
                title: "lang.parts",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["fe_parts.read"],
            },
        },
    ],
};
